import React from "react"
import ReactDOM from "react-dom"
import AirlinePage from "./airline-page-component"

export default class AirlinePageModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.textkeysJson = elem.dataset.textkeysJson && JSON.parse(elem.dataset.textkeysJson)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.tabIcons = elem.dataset.tabIcons && JSON.parse(elem.dataset.tabIcons)
    this.init()
    return self
  }
  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<AirlinePage {...self.modelJson} {...self.tabIcons} {...self.textkeysJson} locale={self.locale} />, self.elem)
  }
}
